import React,{useEffect, useState} from "react";
import Layout from "layouts/layout";
import ListContainer from "components/list/list-container";
import ListHeader from "components/list/list-header";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  SET_USERS_TRASH,
  GET_USERS_TRASH,
  REFRESH_USERS_TRASH,
} from "redux/modules/user-trash/types";
import { urlSerializer } from "utils/utils";
import ToolTip from "components/tooltip/tooltip";
import LockIconSVG from "assets/svg/lock-icon";
import UserProfile from "assets/images/image.png";
import Table from "components/table/table";
import { LuArchiveRestore } from "react-icons/lu";
import ActionIconBtn from "components/button/action-btn";
import _ from "lodash";
import LoadingIndicator from "assets/svg/loading-indicator";
import toast from "react-hot-toast";

export default function UserTrash (){
    const { http } = global.services;
    const query = useQuery();
    const {
        isRequesting,
        initialize,
        loadMore,
        refresh,
        page,
        limit,
        usersTrash = [],
        pages = [],
    } = useSelector((state) => state.userTrash);

    const dispatch = useDispatch();
    const searchValue = query.get("search");
    const [filterValue, setFilterValue] = useState(searchValue);
    const [selectedRows, setSelectedRows] = useState([]);
    const [loadingRestore,setRestore] = useState(false);

    useEffect(() => {
        if (initialize) getUsers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [refresh, initialize]);

    const getUsers = async (selectedPage = null) => {
        if (isRequesting || !loadMore) return;
    
        dispatch({ type: GET_USERS_TRASH, payload: [] });
    
        try {
          const url = urlSerializer("users-trash", {
            search: filterValue,
            page: selectedPage ?? page,
            limit: limit,
          });
          const { data } = await http.get(url);
          const _loadMore = data.data.length > 0 ? true : false;
          // const _page = data.data.length > 0 ? page + 1 : page;
          const _page = data.current_page;
          const _lastPage = data.last_page;
    
          dispatch({
            type: SET_USERS_TRASH,
            payload: {
              data: data.data,
              loadMore: _loadMore,
              page: _page,
              lastPage: _lastPage,
            },
          });
        } catch (err) {
          console.log("error@getUsers", err);
        }
    };

    const handlerRestoreUser = async(item={}) =>{
            setRestore(true)
        try{
            const { data } = await http.post("users-restore", { user_id:item.id });
            toast.success('Successfully Restored')
            dispatch({
                type: REFRESH_USERS_TRASH,
                payload: [],
            });
        }catch(e){
            setRestore(false);
            console.log("error@delete", e);
            toast.error('Something went wrong')
        }finally{
            setRestore(false)
        }
    
      }
    const handleSearch = (e) => {
        e.preventDefault();
    
        dispatch({
          type: REFRESH_USERS_TRASH,
          payload: [],
        });
      };

    const columns = [
    {
      title: "Name",
      dataIndex: "name",
      nowrap: true,
      key: "name",
      render: (record) => (
        <div className="w-full flex items-center">
          {(record?.first_name ||  record?.last_name) ? (
            <div className={`w-full flex items-center hover:bg-sky-700`}>
              <img
                src={record?.profile_image_webp_url || UserProfile}
                alt="account"
                className="account-img mr-2.5 rounded-full"
              />
              <p>
                {record.first_name} {record.last_name} 
              </p>
            </div>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },
    {
      title: "Username",
      dataIndex: "username",
      nowrap: true,
      key: "username",
    },
    {
      title: "User Email",
      dataIndex: "email",
      nowrap: true,
      key: "email",
      render: (record) => (
        <div className="w-full flex items-center">
          <p>
              {record?.email}
            </p>
        </div>
      ),
    },

    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      hideSorting: true,
      nowrap: true,
      render: (record) => (
        <div className="flex">
          <ToolTip
            value={`Restore Account`}
            backgroundColor="#0c6ed1"
            color="white"
            width='117px'
            >
                {
                    loadingRestore ? 
                    <LoadingIndicator className="text-[#0c6ed1] w-4 h-4 ml-2" />
                    :
                    <ActionIconBtn
                        icon={<LuArchiveRestore className="m-auto cursor-pointer" />}
                        onClick={() => handlerRestoreUser(record)}
                    />
                }
           
            </ToolTip> 
        </div>
      ),
    },
  ];

    return(
        <Layout title="Users Deleted" routeName="users-trash">
            <div className="main-page-wrapper">
                <ListContainer
                    header={
                    <ListHeader
                        title="List"
                        countValue={_.size(usersTrash)}
                        filterValue={filterValue}
                        setFilterValue={setFilterValue}
                        // buttonName="+ Add Icon"
                        // showAddButton={true}
                        // onClickButton={() => handleAddEdit()}
                        onSearch={(e) => handleSearch(e)}
                    />
                    }
                >
                    <Table
                        columns={columns}
                        dataSource={usersTrash}
                        pagination={true}
                        selectable={true}
                        selected={selectedRows}
                        onSelected={(selectedRows) => {
                            setSelectedRows(selectedRows);
                        }}
                        perPage={10}
                        currentPage={page}
                        onHandleChangePage={getUsers}
                        pages={pages}
                        />
                </ListContainer>
            </div>
        </Layout>
    )
}

const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
};